import React from 'react';

import EmptyDataBox from '../../../../../assets/images/empty-data-box.png';
import { IEmptyCard } from '../../../../interfaces/cards';
import BdsButton from '../../Buttons/BdsButton/BdsButton';

import './EmptyCard.scss';

const EmptyCard = ({
  className,
  primaryText,
  secondaryText,
  buttonText,
  buttonVariant = 'secondary',
  center = false,
  action,
  secondaryAction,
  secondaryButtonText
}: IEmptyCard) => {
  return (
    <div className={`empty-card-content ${className}`}>
      <img src={EmptyDataBox} className="empty-data-box" alt="Empty Data Box" />
      <div className={`empty-card-texts ${center && 'center'}`}>
        <div className="primary-text">{primaryText}</div>
        {secondaryText && <div className="secondary-text">{secondaryText}</div>}
      </div>
      {buttonText && action && (
        <BdsButton size="m" action={action} variant={buttonVariant}>
          {buttonText}
        </BdsButton>
      )}
      {secondaryButtonText && secondaryAction && (
        <BdsButton size="m" action={secondaryAction} variant="secondary">
          {secondaryButtonText}
        </BdsButton>
      )}
    </div>
  );
};

export default EmptyCard;
